/** @format */

import React from "react"
import { LayoutStyled, LayoutWrapperStyled } from "./UI"
import { AuthenticationProvider } from "@aviv-pro-navigation/authentication";
import { getMspApiUrl } from "_shared/helpers/unifiedRoutingHelper";


export const Layout = ({ children, hasNavigation  }) => {
	return (
		<LayoutStyled className="hyperfaiseur-layout" hasNavigation={hasNavigation}>
			<LayoutWrapperStyled>{children}</LayoutWrapperStyled>
		</LayoutStyled>
	)
}
